import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  FormControl,
  Menu,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from '@mui/material';
import MarketPlaceActionButton from './MarketPlaceActionButton';
import { useTheme } from '@emotion/react';
import { poppins500, poppins600 } from 'theme/common.style';
import { Divider } from 'antd';
import DepositPaymentDetailsNew from 'component/BuyerRegistration/components/DepositPaymentDetailsNew';
import {
  flagDueDelligenceFile,
  getApiCall,
  getDueDelligenceFile,
} from 'api/apiService';
import {
  API_URL,
  GET_DEPOSIT,
  REQUEST_SIGN_TEMPLATE,
} from 'constant/app.config';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';
import ConfirmDueDiligence from 'component/BuyerRegistration/components/ConfirmDueDiligence';
import CommenceESignDialog from './CommenceESignDialog';
import { useParams } from 'react-router-dom';
import ViewCommenceEsignPdf from './ViewCommenceEsignPdf';

const ActionButtonChecklist = ({
  ApicallDueDiligence,
  groupCall,
  data,
  task,
  checkListArray,
  getBuyerIndividualData,
  getBuyerIndividualValue,
  sharedpage,
  openMessage,
  setContractReviewed,
  setDueDiligence,
  setOpenlogin,
  openlogin,
  propertyInspected,
  setPropertyInspected,
  userId,
  setTabDAta,
  handleMakeOfferClick,
  setNewTabData,
  action,
  classes,
  uploadDoc,
  commenceBinder,
  setPaymentPop,
  setOpenBoxSign,
  depositPaymentBuyer,
  setDepositPaymentBuyer,
  signContract,
  setSignContract,
  sixtySixWCertificate,
  setSixtySixWCertificate,
  contractReviewed,
  viewContractBuyer,
  setViewContractBuyer,
  dueDiligence,
  request_E_signIcon,
  commence_E_SignIcon,
  setRequesttoview,
  userDetail,
  setOpensolicitorpopup,
  setTypeofsolicitorpopup,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [depositeopen, setDepositeopen] = React.useState(false);
  const [openConfirmDueDiligence, SetOpenConfirmDueDiligence] =
    React.useState(false);
  const propertyId =
    getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;
  const location = useLocation();
  const history = useHistory();
  const [openESign, setOpenESign] = useState(false);
  const [pdfMeta, setPdfMeta] = useState(null);
  const params = useParams();
  const primaryUserTypeValue = userDetail?.userType[0]?.userType;

  useEffect(() => {
    if (
      task?.taskName == 'Deposit Payment' &&
      location.state?.isDepositPaymentBanner == true
    ) {
      GetDeposit();
      history.push({
        pathname: history.location.pathname,
        state: { propertyIds: true, isDepositPaymentBanner: false },
      });
    }
  }, [location.state]);

  const uploadVal =
    task?.taskName == 'Deposit Payment'
      ? task?.taskStatus !== 'Action Required'
      : true;
  const requestVal =
    task?.taskName == '66w Certificate'
      ? task?.taskStatus == 'Requested'
      : false;
  const eSignStatus =
    task?.taskName == 'Sign Contract'
      ? task?.taskStatus != 'Action Required'
      : true;
  const statusVal =
    checkListArray[2]?.taskStatus == 'Reviewed' &&
    checkListArray[3]?.taskStatus == 'Action Required'
      ? false
      : true;
  const docVal = statusVal;

  const [getDeposit, setGetDeposit] = useState();
  const GetDeposit = () => {
    let accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');
    getApiCall(`${GET_DEPOSIT.replace(/\/$/, '')}/${propertyId}`, {
      method: 'GET',
      headers: {
        Authorization: accesstoken,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      setGetDeposit(res?.data);
      setDepositPaymentBuyer(false);
      setDepositeopen(true);
    });
  };
  const [conditioncheck, setConditioncheck] = useState(false);

  useEffect(() => {
    let condition = () => {
      if (sharedpage) {
        return true;
      } else if (
        getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause'
      ) {
        return true;
      } else if (
        getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'End' &&
        getBuyerIndividualValue?.PropertyDetails?.isWinner == 1
      ) {
        if (getBuyerIndividualValue?.PropertyDetails?.isWinnerId == userId) {
          return false;
        } else {
          return true;
        }
      } else if (
        getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'End' &&
        getBuyerIndividualValue?.PropertyDetails?.isWinner == 0
      ) {
        return false;
      } else return false;
    };
    setConditioncheck(condition);
  }, [getBuyerIndividualValue]);

  const handleCommenceESign = async () => {
    try {
      const response = await getApiCall(
        `${REQUEST_SIGN_TEMPLATE}?propertyId=${params?.propertyId}`
      );
      if (response?.data?.status === 1) {
        const { contractFile, fields } = response.data;

        setPdfMeta({
          contractFile,
          fields,
        });

        setOpenESign(true);
      }
    } catch (error) {
      console.error('Failed to fetch sign template', error);
    }
  };

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const handleOpenView = (task) => {
    setSelectedTask(task);
    setOpenViewDialog(true);
  };

  const handleCloseView = () => {
    setOpenViewDialog(false);
    setSelectedTask(null);
  };

  return (
    <FormControl
      sx={{
        minWidth: '60px',
      }}
      size="small"
    >
      {task?.taskCode == 'Ins001' && (
        <Typography
          onClick={() => {
            if (sharedpage) {
              setOpenlogin(!openlogin);
            }
          }}
        >
          {matchessm ? (
            <MarketPlaceActionButton
              sectionName={'Property Inspected'}
              open={propertyInspected}
              setOpen={setPropertyInspected}
              disabledCondition={conditioncheck}
              renderData={
                <>
                  <MenuItem
                    sx={{
                      textAlign: 'center',
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      setPropertyInspected(false);
                      setTabDAta('1');
                      window.scroll({
                        top: window.scrollY + window.innerHeight / 2 + 100,
                        behavior: 'smooth',
                      });
                    }}
                    value={10}
                  >
                    Manage
                  </MenuItem>
                </>
              }
            />
          ) : (
            <Select
              id="optionlist"
              sx={{
                ...poppins500,
                fontSize: '12px',
                fontColor: '#112347',
                height: '30px',
                borderRadius: '6px',
                border: !conditioncheck ? '1px solid #6C2AD2' : 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                boxShadow: conditioncheck && '0px 1px 4px rgba(0, 0, 0, 0.15)',
              }}
              value={action}
              disabled={conditioncheck}
              className={classes.disabledSelect}
              inputProps={{
                'aria-label': 'Without label',
              }}
            >
              <MenuItem
                value={'Action'}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  display: 'none',
                  color: '#112347',
                }}
              >
                Action
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setTabDAta('1');
                  window.scroll({
                    top: window.scrollY + window.innerHeight / 2 + 100,
                    behavior: 'smooth',
                  });
                }}
                value={10}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                Manage
              </MenuItem>
            </Select>
          )}
        </Typography>
      )}
      {task?.taskCode == 'Due001' && (
        <Typography
          onClick={() => {
            if (sharedpage) {
              setOpenlogin(!openlogin);
            }
          }}
        >
          {matchessm ? (
            <MarketPlaceActionButton
              sectionName={'Due Diligence'}
              open={dueDiligence}
              setOpen={setDueDiligence}
              disabledCondition={conditioncheck}
              renderData={
                <>
                  <MenuItem
                    onClick={() => {
                      setDueDiligence(false);
                      setTabDAta('3');
                      setNewTabData(true);
                      window.scroll({
                        top: window.scrollY + window.innerHeight / 2 + 100,
                        behavior: 'smooth',
                      });
                    }}
                    value={20}
                    sx={{
                      textAlign: 'center',
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    View
                  </MenuItem>
                  {/* Show text only when NO link is present */}
                  {!(
                    data?.StrataLink?.propertyMedia?.trim() ||
                    data?.BuildingPestLink?.propertyMedia?.trim()
                  ) && (
                    <MenuItem
                      onClick={() => {
                        SetOpenConfirmDueDiligence(true);
                      }}
                      disabled={task.taskStatus === 'Reviewed'}
                      value={40}
                      sx={{
                        textAlign: 'center',
                        ...poppins600,
                        fontSize: '20px',
                        color: '#349BFA',
                        width: '100%',
                        justifyContent: 'center',
                        // Blur only when task is completed (Reviewed)
                        filter:
                          task.taskStatus === 'Reviewed'
                            ? 'blur(0.5px)'
                            : 'none',
                        opacity: task.taskStatus === 'Reviewed' ? 0.7 : 1,
                      }}
                    >
                      {task.taskStatus == 'Reviewed'
                        ? 'Mark as Completed'
                        : 'Mark as Complete'}
                    </MenuItem>
                  )}
                </>
              }
            />
          ) : (
            <Select
              id="optionlist"
              sx={{
                ...poppins500,
                fontSize: '12px',
                fontColor: '#112347',
                height: '30px',
                borderRadius: '6px',
                border: !conditioncheck ? '1px solid #6C2AD2' : 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                boxShadow: conditioncheck && '0px 1px 4px rgba(0, 0, 0, 0.15)',
              }}
              value={action}
              disabled={conditioncheck}
              className={classes.disabledSelect}
              inputProps={{
                'aria-label': 'Without label',
              }}
            >
              <MenuItem
                value={'Action'}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                  display: 'none',
                }}
              >
                Action
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setTabDAta('3');
                  window.scroll({
                    top: window.scrollY + window.innerHeight / 2 + 100,
                    behavior: 'smooth',
                  });
                }}
                value={20}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                View
              </MenuItem>
              {/* Show text only when NO link is present */}
              {!(
                data?.StrataLink?.propertyMedia?.trim() ||
                data?.BuildingPestLink?.propertyMedia?.trim()
              ) && (
                <MenuItem
                  onClick={() => {
                    SetOpenConfirmDueDiligence(true);
                  }}
                  value={40}
                  disabled={task.taskStatus === 'Reviewed'}
                  sx={{
                    ...poppins500,
                    fontSize: '12px',
                    color: '#112347',
                    // Blur only when task is completed (Reviewed)
                    filter:
                      task.taskStatus === 'Reviewed' ? 'blur(0.5px)' : 'none',
                    opacity: task.taskStatus === 'Reviewed' ? 0.7 : 1,
                  }}
                >
                  {task.taskStatus == 'Reviewed'
                    ? 'Mark as Completed'
                    : 'Mark as Complete'}
                </MenuItem>
              )}
            </Select>
          )}
        </Typography>
      )}

      {task?.taskCode == 'Con001' && (
        <Typography
          onClick={() => {
            if (sharedpage) {
              setOpenlogin(!openlogin);
            }
          }}
        >
          {matchessm ? (
            <MarketPlaceActionButton
              sectionName={'View Contract'}
              open={viewContractBuyer}
              setOpen={setViewContractBuyer}
              disabledCondition={conditioncheck}
              renderData={
                <>
                  <MenuItem
                    value={30}
                    onClick={() => {
                      setViewContractBuyer(false);
                      setTabDAta('2');
                      setNewTabData(true);
                      window.scroll({
                        top: window.scrollY + window.innerHeight / 2 + 100,
                        behavior: 'smooth',
                      });
                      if (
                        checkListArray[2]?.taskStatus == 'Action Required' ||
                        checkListArray[2]?.taskStatus == 'Pending'
                      ) {
                        setRequesttoview(true);
                      }
                    }}
                    sx={{
                      textAlign: 'center',
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    {checkListArray[2]?.taskStatus == 'Action Required' ||
                    checkListArray[2]?.taskStatus == 'Pending'
                      ? 'Request'
                      : 'View'}
                  </MenuItem>

                  <MenuItem
                    value={50}
                    onClick={() => {
                      setTypeofsolicitorpopup('forwardContract');
                      setOpensolicitorpopup(true);
                    }}
                    sx={{
                      textAlign: 'center',
                      ...poppins600,
                      fontSize: '20px',
                      width: '100%',
                      justifyContent: 'center',
                      color: '#112347',
                    }}
                  >
                    {checkListArray[3]?.taskStatus == 'Completed'
                      ? 'Forwarded to Solicitor'
                      : checkListArray[3]?.taskStatus == 'Action Required'
                      ? 'Forward to Solicitor'
                      : 'Forwarded to Solicitor'}
                  </MenuItem>
                </>
              }
            />
          ) : (
            <Select
              id="optionlist"
              sx={{
                ...poppins500,
                fontSize: '12px',
                fontColor: '#112347',
                height: '30px',
                borderRadius: '6px',
                border: !conditioncheck ? '1px solid #6C2AD2' : 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                boxShadow: conditioncheck && '0px 1px 4px rgba(0, 0, 0, 0.15)',
              }}
              value={action}
              disabled={conditioncheck}
              className={classes.disabledSelect}
              inputProps={{
                'aria-label': 'Without label',
              }}
            >
              <MenuItem
                value={'Action'}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                  display: 'none',
                }}
              >
                Action
              </MenuItem>
              <MenuItem
                value={30}
                onClick={() => {
                  setTabDAta('2');
                  window.scroll({
                    top: window.scrollY + window.innerHeight / 2 + 100,
                    behavior: 'smooth',
                  });
                  if (
                    checkListArray[2]?.taskStatus == 'Action Required' ||
                    checkListArray[2]?.taskStatus == 'Pending'
                  ) {
                    setRequesttoview(true);
                  }
                }}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                {checkListArray[2]?.taskStatus == 'Action Required' ||
                checkListArray[2]?.taskStatus == 'Pending'
                  ? 'Request'
                  : 'View'}
              </MenuItem>

              <MenuItem
                value={50}
                onClick={() => {
                  setTypeofsolicitorpopup('forwardContract');
                  setOpensolicitorpopup(true);
                }}
                disabled={
                  checkListArray[3]?.taskStatus == 'Completed' ||
                  checkListArray[2]?.taskStatus != 'Reviewed'
                }
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                {checkListArray[3]?.taskStatus == 'Completed'
                  ? 'Forwarded to Solicitor'
                  : checkListArray[3]?.taskStatus == 'Action Required'
                  ? 'Forward to Solicitor'
                  : 'Forwarded to Solicitor'}
              </MenuItem>
            </Select>
          )}
        </Typography>
      )}
      {task?.taskCode == 'RevCon001' && (
        <Typography
          onClick={() => {
            if (sharedpage) {
              setOpenlogin(!openlogin);
            }
          }}
        >
          {matchessm ? (
            <MarketPlaceActionButton
              sectionName={'Contract Reviewed'}
              open={contractReviewed}
              setOpen={setContractReviewed}
              disabledCondition={conditioncheck}
              renderData={
                <>
                  <MenuItem
                    value={60}
                    disabled={
                      checkListArray[3]?.taskStatus == 'Completed' ||
                      checkListArray[2]?.taskStatus != 'Reviewed'
                    }
                    onClick={() => {
                      setTypeofsolicitorpopup('forwardContract');
                      setOpensolicitorpopup(true);
                    }}
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      width: '100%',
                      justifyContent: 'center',
                      color: '#112347',
                    }}
                  >
                    {checkListArray[3]?.taskStatus == 'Completed'
                      ? 'Forwarded to Solicitor'
                      : checkListArray[3]?.taskStatus == 'Action Required'
                      ? 'Forward to Solicitor'
                      : 'Forwarded to Solicitor'}
                  </MenuItem>

                  <MenuItem
                    value={70}
                    disabled={docVal}
                    onClick={() => {
                      setContractReviewed(false);
                      uploadDoc();
                    }}
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    Mark as Complete
                  </MenuItem>

                  <MenuItem
                    value={80}
                    disabled={
                      checkListArray[3]?.taskStatus == 'Action Required' ||
                      checkListArray[3]?.taskStatus == 'Completed'
                    }
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      setContractReviewed(false);
                      const binderId = checkListArray[3]?.binderId;
                      if (binderId) {
                        openMessage(binderId);
                      }
                    }}
                  >
                    Follow Up
                  </MenuItem>
                </>
              }
            />
          ) : (
            <Select
              id="optionlist"
              sx={{
                ...poppins500,
                fontSize: '12px',
                fontColor: '#112347',
                height: '30px',
                borderRadius: '6px',
                border: !conditioncheck ? '1px solid #6C2AD2' : 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                boxShadow: conditioncheck && '0px 1px 4px rgba(0, 0, 0, 0.15)',
              }}
              value={action}
              disabled={conditioncheck}
              className={classes.disabledSelect}
              inputProps={{
                'aria-label': 'Without label',
              }}
            >
              <MenuItem
                value={'Action'}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                  display: 'none',
                  borderColor: ' #6C2AD2',
                }}
              >
                Action
              </MenuItem>
              <MenuItem
                value={60}
                disabled={
                  checkListArray[3]?.taskStatus == 'Completed' ||
                  checkListArray[2]?.taskStatus != 'Reviewed'
                }
                onClick={() => {
                  setTypeofsolicitorpopup('forwardContract');
                  setOpensolicitorpopup(true);
                }}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                {checkListArray[3]?.taskStatus == 'Completed'
                  ? 'Forwarded to Solicitor'
                  : checkListArray[3]?.taskStatus == 'Action Required'
                  ? 'Forward to Solicitor'
                  : 'Forwarded to Solicitor'}
              </MenuItem>
              <MenuItem
                value={70}
                disabled={docVal}
                onClick={uploadDoc}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                Mark as Complete
              </MenuItem>
              <MenuItem
                value={80}
                disabled={
                  checkListArray[3]?.taskStatus == 'Action Required' ||
                  checkListArray[3]?.taskStatus == 'Completed'
                }
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
                onClick={() => {
                  const binderId = checkListArray[3]?.binderId;
                  if (binderId) {
                    openMessage(binderId);
                  }
                }}
              >
                Follow Up
              </MenuItem>
            </Select>
          )}
        </Typography>
      )}
      {task?.taskCode == '66W001' && (
        <Typography
          onClick={() => {
            if (sharedpage) {
              setOpenlogin(!openlogin);
            }
          }}
        >
          {matchessm ? (
            <MarketPlaceActionButton
              sectionName={'66W Certificate'}
              open={sixtySixWCertificate}
              setOpen={setSixtySixWCertificate}
              disabledCondition={conditioncheck}
              renderData={
                <>
                  <MenuItem
                    disabled={
                      !['Action Required', 'Requested'].includes(
                        checkListArray[4]?.taskStatus
                      )
                    }
                    value={90}
                    onClick={() => {
                      setTypeofsolicitorpopup('request66w');
                      setOpensolicitorpopup(true);
                    }}
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    {checkListArray[4]?.taskStatus != 'Action Required'
                      ? 'Requested s66W'
                      : 'Request s66W'}
                  </MenuItem>

                  <MenuItem
                    value={100}
                    disabled={
                      checkListArray[4]?.taskStatus == 'Action Required' ||
                      checkListArray[4]?.taskStatus == 'Completed'
                    }
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      setSixtySixWCertificate(false);
                      const binderId = checkListArray[4]?.binderId;
                      if (binderId) {
                        openMessage(binderId);
                      }
                    }}
                  >
                    Follow Up
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setSixtySixWCertificate(false);
                    }}
                    value={110}
                    disabled={checkListArray[4]?.taskStatus !== 'Completed'}
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    View
                  </MenuItem>
                </>
              }
            />
          ) : (
            <Select
              id="optionlist"
              sx={{
                ...poppins500,
                fontSize: '12px',
                fontColor: '#112347',
                height: '30px',
                borderRadius: '6px',
                border: !conditioncheck ? '1px solid #6C2AD2' : 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                boxShadow: conditioncheck && '0px 1px 4px rgba(0, 0, 0, 0.15)',
              }}
              value={action}
              disabled={conditioncheck}
              className={classes.disabledSelect}
              inputProps={{
                'aria-label': 'Without label',
              }}
            >
              <MenuItem
                value={'Action'}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                  display: 'none',
                }}
              >
                Action
              </MenuItem>
              <MenuItem
                disabled={
                  !['Action Required', 'Requested'].includes(
                    checkListArray[4]?.taskStatus
                  )
                }
                value={90}
                onClick={() => {
                  setTypeofsolicitorpopup('request66w');
                  setOpensolicitorpopup(true);
                }}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                {checkListArray[4]?.taskStatus != 'Action Required'
                  ? 'Requested s66W'
                  : 'Request s66W'}
              </MenuItem>

              <MenuItem
                value={100}
                disabled={
                  checkListArray[4]?.taskStatus == 'Action Required' ||
                  checkListArray[4]?.taskStatus == 'Completed'
                }
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
                onClick={() => {
                  const binderId = checkListArray[4]?.binderId;
                  if (binderId) {
                    openMessage(binderId);
                  }
                }}
              >
                Follow Up
              </MenuItem>
              <MenuItem
                value={110}
                disabled={checkListArray[4]?.taskStatus !== 'Completed'}
                onClick={() => handleOpenView(task)}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                View
              </MenuItem>
            </Select>
          )}
        </Typography>
      )}
      {task?.taskCode == 'SignCon001' && (
        <Typography
          onClick={() => {
            if (sharedpage) {
              setOpenlogin(!openlogin);
            }
          }}
        >
          {matchessm ? (
            <MarketPlaceActionButton
              sectionName={'Sign Contract'}
              open={signContract}
              setOpen={setSignContract}
              disabledCondition={conditioncheck}
              renderData={
                <>
                  <MenuItem
                    disabled={
                      eSignStatus ||
                      checkListArray[3]?.taskStatus != 'Completed'
                    }
                    value={120}
                    onClick={() => {
                      setSignContract(false);
                      setOpenBoxSign(true);
                    }}
                    sx={{
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins600,
                        flex: 1,
                        textAlign: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        color: '#349BFA',
                      }}
                    >
                      Request E-Sign
                    </Typography>
                  </MenuItem>

                  <MenuItem
                    disabled={task?.taskStatus != 'Pending Buyer Signature'}
                    onClick={() => {
                      setSignContract(false);
                      handleCommenceESign();
                    }}
                    value={130}
                    sx={{
                      width: '100%',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins600,
                        flex: 1,
                        textAlign: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        color: '#349BFA',
                      }}
                    >
                      Commence E-Sign
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    disabled={task?.taskPath == null}
                    value={140}
                    onClick={() => handleOpenView(task)}
                    sx={{
                      width: '100%',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins600,
                        flex: 1,
                        textAlign: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        color: '#349BFA',
                      }}
                    >
                      View
                    </Typography>
                  </MenuItem>
                </>
              }
            />
          ) : (
            <Select
              id="optionlist"
              sx={{
                ...poppins500,
                fontSize: '12px',
                fontColor: '#112347',
                height: '30px',
                borderRadius: '6px',
                border: !conditioncheck ? '1px solid #6C2AD2' : 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                boxShadow: conditioncheck && '0px 1px 4px rgba(0, 0, 0, 0.15)',
              }}
              value={action || ''}
              disabled={conditioncheck}
              className={classes.disabledSelect}
              inputProps={{
                'aria-label': 'Without label',
              }}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return <span style={{ color: '#112347' }}>Action</span>;
                }
                return selected;
              }}
            >
              <MenuItem
                disabled={
                  eSignStatus || checkListArray[3]?.taskStatus != 'Completed'
                }
                value={120}
                onClick={() => {
                  setOpenBoxSign(true);
                }}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                Request E-Sign
              </MenuItem>
              <MenuItem
                disabled={task?.taskStatus != 'Pending Buyer Signature'}
                onClick={handleCommenceESign}
                value={130}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                Commence E-Sign
              </MenuItem>
              <MenuItem
                disabled={task?.taskPath == null}
                value={140}
                onClick={() => handleOpenView(task)}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                View
              </MenuItem>
            </Select>
          )}
        </Typography>
      )}
      {task?.taskCode == 'DepPay001' && (
        <Typography
          onClick={() => {
            if (sharedpage) {
              setOpenlogin(!openlogin);
            }
          }}
        >
          {matchessm ? (
            <MarketPlaceActionButton
              sectionName="Deposit Payment"
              open={depositPaymentBuyer}
              setOpen={setDepositPaymentBuyer}
              disabledCondition={conditioncheck}
              renderData={
                <>
                  <MenuItem
                    onClick={() => {
                      GetDeposit();
                    }}
                    value={140}
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    View Details
                  </MenuItem>

                  <MenuItem
                    disabled={
                      getBuyerIndividualValue?.PropertyDetails?.isWinner == 0 ||
                      getBuyerIndividualValue?.PropertyDetails?.isWinnerId !=
                        userId ||
                      (uploadVal &&
                        getBuyerIndividualValue?.isDepositReceived == 1) ||
                      getBuyerIndividualValue?.isDepositReceived == 0
                    }
                    value={150}
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      setDepositPaymentBuyer(false);
                      setPaymentPop(true);
                    }}
                  >
                    Upload Remittance
                  </MenuItem>

                  <MenuItem
                    disabled={true}
                    value={160}
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#349BFA',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    Request deposit Refund
                  </MenuItem>
                </>
              }
            />
          ) : (
            <Select
              id="optionlist"
              sx={{
                ...poppins500,
                fontSize: '12px',
                fontColor: '#112347',
                height: '30px',
                borderRadius: '6px',
                border: !conditioncheck ? '1px solid #6C2AD2' : 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                boxShadow: conditioncheck && '0px 1px 4px rgba(0, 0, 0, 0.15)',
              }}
              value={action}
              disabled={conditioncheck}
              className={classes.disabledSelect}
              inputProps={{
                'aria-label': 'Without label',
              }}
            >
              <MenuItem
                value={'Action'}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                  display: 'none',
                }}
              >
                Action
              </MenuItem>
              <MenuItem
                value={140}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
                onClick={() => {
                  GetDeposit();
                }}
              >
                View Details
              </MenuItem>
              <MenuItem
                disabled={
                  getBuyerIndividualValue?.PropertyDetails?.isWinner == 0 ||
                  getBuyerIndividualValue?.PropertyDetails?.isWinnerId !=
                    userId ||
                  (uploadVal &&
                    getBuyerIndividualValue?.isDepositReceived == 1) ||
                  getBuyerIndividualValue?.isDepositReceived == 0
                }
                value={150}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
                onClick={() => {
                  setPaymentPop(true);
                }}
              >
                Upload Remittance
              </MenuItem>

              <MenuItem
                disabled={true}
                value={160}
                sx={{
                  ...poppins500,
                  fontSize: '12px',
                  color: '#112347',
                }}
              >
                Request deposit Refund
              </MenuItem>
            </Select>
          )}
        </Typography>
      )}
      <DepositPaymentDetailsNew
        open={depositeopen}
        setDepositeopen={setDepositeopen}
        data={getDeposit}
        getBuyerIndividualValue={getBuyerIndividualValue}
        setPaymentPop={setPaymentPop}
        setTabDAta={setTabDAta}
        handleMakeOfferClick={handleMakeOfferClick}
      />
      <ConfirmDueDiligence
        open={openConfirmDueDiligence}
        SetOpenConfirmDueDiligence={SetOpenConfirmDueDiligence}
        getBuyerIndividualValue={getBuyerIndividualValue}
        ApicallDueDiligence={ApicallDueDiligence}
        groupCall={groupCall}
        data={data}
      />
      {openESign && (
        <CommenceESignDialog
          open={openESign}
          onClose={() => setOpenESign(false)}
          pdfMeta={pdfMeta}
          streetName={
            getBuyerIndividualValue?.PropertyDetails?.propertyAddress
              ?.streetName
          }
          matchessm={matchessm}
          userDetail={userDetail}
          propertyId={propertyId}
          getListInfo={groupCall}
        />
      )}
      {openViewDialog && (
        <ViewCommenceEsignPdf
          open={openViewDialog}
          onClose={handleCloseView}
          taskPath={selectedTask?.taskPath}
          streetName={
            getBuyerIndividualValue?.PropertyDetails?.propertyAddress
              ?.streetName
          }
          wStatus={selectedTask?.taskName == '66w Certificate'}
          statusLastUpdatedAt={selectedTask?.statusLastUpdatedAt}
          primaryUserTypeValue={primaryUserTypeValue}
          isArchived={
            getBuyerIndividualValue?.PropertyDetails?.isArchived === 1
          }
        />
      )}
    </FormControl>
  );
};

export default ActionButtonChecklist;
